import { memo } from "react";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";

interface TaskSheetHeaderProps {
  onClose: () => void;
  title?: string;
}

export const TaskSheetHeader = memo((props: TaskSheetHeaderProps) => {
  const { title = "", onClose } = props;
  return <FixaModalHeader closeBtnClick={onClose} title={title} />;
});
